<template lang="pug">  
div.initial-text
    p(v-for="label in (initialText || '').split('|')" v-html="label")
        | {{label}}		
</template>
<script>

import { mapGetters } from 'vuex';

export default {
  name: 'InitialText',
  computed: {
      ...mapGetters(['currentStep']),
      initialText(){
      	if(this.text == null){
      		return this.currentStep.initialText;
      	}else{
      		return this.text;
      	}
      }
  },
  props: {
  	text: String
  }
}
</script>

<style scoped>
@import 'initial-text.scss';
</style>

